<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content" *ngIf="!spinnerLoading">
    <h3 i18n='Attributes edit modal title@@customerOverviewComponent.modalTitle.editAttributes'>Edit attributes</h3>
    <form [formGroup]="updateAttributeForm" (ngSubmit)="submitCustomerAttributes()" id="updateAttributeForm">

      <table class="esf-table">
        <thead class="esf-table__head">
          <tr class="esf-table__row">
            <th class="esf-table__cell esf-table__cell--head"
                i18n-data-label='Table cell heading@@general.tableCellLabel.name'
                data-label="Name">
              <span class="esf-table__cell-inner"
                    i18n='Table cell heading@@general.tableCellLabel.name'>Name</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head"
                i18n-data-label='Table cell heading@@general.tableCellLabel.description'
                data-label="Description">
              <span class="esf-table__cell-inner"
                    i18n='Table cell heading@@general.tableCellLabel.description'>Description</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head"
                i18n-data-label='Table cell heading@@general.tableCellLabel.status'
                data-label="Status">
              <span class="esf-table__cell-inner"
                    i18n='Table cell heading@@general.tableCellLabel.status'>Status</span>
            </th>
          </tr>
        </thead>
        <tbody class="esf-table__body">
          <ng-container *ngFor="let attribute of clubAttributes">

            <tr class="esf-table__row"
                *ngIf="attribute.status === 'active' && !attribute.internal">
              <td class="esf-table__cell"
                  data-label="Name">
                <span class="esf-table__cell-inner">
                  <a class="esf-tag"
                     [ngClass]="{'text-color-dark': !attribute.isDark, 'text-color-light': attribute.isDark}"
                     [style.background-color]="attribute.color">{{ attribute.name }}</a>
                </span>
              </td>

              <td class="esf-table__cell"
                  data-label="Description">
                <span class="esf-table__cell-inner">{{ attribute.description }}</span>
              </td>

              <td class="esf-table__cell"
                  data-label="Status"
                  *ngIf="attributeLoadingId !== attribute.id">
                <div class="esf-toggle">
                  <input class="esf-toggle__input"
                         type="checkbox"
                         [id]="attribute.id"
                         [checked]="attribute.checked"
                         [disabled]="!attribute.assignable"
                         (change)="attribute.checked = !attribute.checked">
                  <label class="esf-toggle__label"
                         [for]="attribute.id">
                    <div class="esf-toggle__button">
                      <div class="esf-toggle__button-background">
                        <div class="esf-toggle__button-handle"></div>
                      </div>
                    </div>
                  </label>
                </div>
              </td>
              <td class="esf-table__cell"
                  data-label="Status"
                  *ngIf="attributeLoadingId === attribute.id">
                <div class="esf-spinner flex-container">
                  <div class="row">
                    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
                    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
                    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
                  </div>
                </div>
              </td>
            </tr>

          </ng-container>
        </tbody>
      </table>
    </form>
  </div>
  <div class="esf-main-sidebar__content" *ngIf="spinnerLoading">
    <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateAttributeForm'"
                          [isFieldValid]="customer.isEditable"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerSubmitName"
                          (cancelButton)="customerService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
